export const COMMON_URLS = {
  DOWNLOAD_FILE: '/common/download',
  MASTER_CONFIG: '/MasterConfig',
  VIEW_FILE: '/common/view',
  DOWNLOAD_APPLICATION_PDF: '/application-form/admins/:application_id/pdf'
};
